import { useCallback, useEffect, useMemo, useState } from 'react';
import { getMarketCart, setMarketQty, removeFromMarketCart, clearMarketCart, lineTotal, seriesDiscounts, itemKey } from '../lib/marketCart';

/** Live view of the Runners' Market cart (localStorage `lgra_market_cart_v1`) — the
 *  SAME store the product pages write to and /runner-market/cart checks out from. */
export const useMarketCart = () => {
  const [items, setItems] = useState(getMarketCart);
  useEffect(() => {
    const sync = () => setItems(getMarketCart());
    window.addEventListener('market-cart-change', sync); window.addEventListener('storage', sync);
    return () => { window.removeEventListener('market-cart-change', sync); window.removeEventListener('storage', sync); };
  }, []);
  const subtotal = useMemo(() => items.reduce((s, i) => s + lineTotal(i), 0), [items]);
  const discounts = useMemo(() => seriesDiscounts(items), [items]);
  const discountTotal = discounts.reduce((s, d) => s + d.amount_rm, 0);
  const setQty = useCallback((key, n) => setMarketQty(key, n), []);
  const remove = useCallback((key) => removeFromMarketCart(key), []);
  return { items, count: items.length, subtotal, discounts, discountTotal, total: subtotal - discountTotal, setQty, remove, clear: clearMarketCart, itemKey };
};

/** Add to the market cart; resolves true only after the store was actually written. */
export const addToMarketCartChecked = (addFn, item) => {
  try {
    const before = getMarketCart();
    const after = addFn(item);
    const k = itemKey(item);
    const line = after.find((i) => itemKey(i) === k);
    const was = before.find((i) => itemKey(i) === k);
    if (!line) return { ok: false, reason: 'Item was not saved to your cart' };
    return { ok: true, line, merged: !!was };
  } catch (e) {
    return { ok: false, reason: 'Your browser blocked saving the cart (storage disabled or full)' };
  }
};
